import React, { useEffect, useState } from 'react';

import { PanelsEnum } from '@ariksa/inventory-core/api';
import { useDisclosure } from '@chakra-ui/react';
import { isEmpty, map, sumBy } from 'lodash';
import { useSelector } from 'react-redux';

import formatNumber, {
  formatNumberWithComma,
} from 'components/DataDisplay/Utils/formatNumber';
import { getIconColor } from 'components/Icons/Components/getIconColor';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import { selectCloudPostureOverview } from 'containers/Dashboard/CloudPostureOverview/selectors';
import { AllEntitiesDrawer } from 'containers/Dashboard/Drawers/AllEntitiesDrawer';
import { AllEntitiesDetailsProps } from 'containers/Dashboard/types';
import { renderNoEntitiesFoundWithIcon } from 'containers/Dashboard/utils';
import { renderResourcesWithIconAndCount } from 'containers/Dashboard/utils/utils';

export const InfrastructureThatLacksEncryption: React.FC = () => {
  const { infrastructureThatLacksEncryption } = useSelector(
    selectCloudPostureOverview,
  );
  const allEntitiesDisclosure = useDisclosure();
  const [details, setDetails] = useState<AllEntitiesDetailsProps>(
    {} as AllEntitiesDetailsProps,
  );
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTotal(
      sumBy(infrastructureThatLacksEncryption.data, o => o.resource_count ?? 0),
    );
  }, [infrastructureThatLacksEncryption.data]);

  return (
    <>
      <DashboardWidget
        isLoading={infrastructureThatLacksEncryption.isLoading}
        label="Entities Lacking Encryption"
        noData={isEmpty(infrastructureThatLacksEncryption.data)}
        noDataMessage={renderNoEntitiesFoundWithIcon()}
        subHeader={
          formatNumberWithComma(total) + ' entit' + (total === 1 ? 'y' : 'ies')
        }
        content={renderResourcesWithIconAndCount(
          map(infrastructureThatLacksEncryption.data, o => ({
            label: o.agnostic_name!,
            iconType: o.agnostic_class!,
            count: formatNumber(o?.resource_count),
            iconColor: getIconColor(o.agnostic_class!),
            onClick: () => {
              allEntitiesDisclosure.onOpen();
              setDetails({
                panel: PanelsEnum.UnencryptedInfraEntities,
                iconType: o.agnostic_class!,
                resourceType: o.agnostic_class!,
                resourceTypeClass: 'agnostic',
                total: o?.resource_count ?? 0,
              });
            },
          })),
        )}
        styles={{ contentWrapper: { px: 0, pb: 0 } }}
      />
      <AllEntitiesDrawer
        isOpen={allEntitiesDisclosure.isOpen}
        onClose={allEntitiesDisclosure.onClose}
        {...details}
      />
    </>
  );
};
